import DodoneContext from 'app/dodones/Context'
import DodoneShowFooter from 'app/dodones/show/Footer'
import DodoneShowGenericBody from 'app/dodones/generic/show/Body'
import DodonesFields from 'app/dodones/shared/Fields'
import DodonesList from 'app/dodones/list/Index'
import HeaderContext from 'app/HeaderContext'
import DodoableDodones from 'app/dodoables/Dodones'
import DodoableDodonesLink from 'app/dodones/shared/DodoableDodonesLink'

export default ({ children, chronometerParameters = {} }) => {
  const { dodone, updateDodone } = useContext(DodoneContext)
  const { setText } = useContext(HeaderContext)
  const [attributes, setAttributes] = useState({})

  useEffect(() => {
    setText(dodone.dodoable.name)
  }, [dodone.id])

  return (
    <>
      <div className="flex-1 fcol">
        {dodone.isClosed && (
          <div className="fcol mb-2" style={{ scrollY: 'auto' }}>
            <DodoableDodonesLink
              className="text-blue-500 text-lg text-right"
              dodoableId={dodone.dodoableId}
              text="Previously &rarr;"
            />
          </div>
        )}
        <DodoneShowGenericBody
          attributes={attributes}
          chronometerParameters={chronometerParameters}
        />
        <DodonesFields dodone={dodone} updateDodone={updateDodone} />
        {children}
        <DodonesList dodones={dodone.children} />
      </div>
      <DodoneShowFooter dodone={dodone} attributes={attributes} />
    </>
  )
}
